import * as React from "react";
import { AuthManager } from "../../auth/AuthContext";
import Img from "../Image";
import ViewportImage from "../ViewportImage";

type ImageResultsProps = {
  images: ViewportImage[];
  onSelectImage: (image: ViewportImage) => void;
  authManager: AuthManager;
};

function ImageResults({ images, onSelectImage, authManager }: ImageResultsProps) {
  return (
    <div>
      <p>Gleamer results</p>
      <div className="image-list">
        {images.map(
          (viewportImage) =>
            viewportImage.result && (
              <div
                key={viewportImage.path}
                className={viewportImage.selected ? "img-cont selected" : "img-cont"}
                onClick={() => onSelectImage(viewportImage)}
              >
                <Img className="img-thumbnail" authManager={authManager} src={viewportImage.image.thumbnailPath} />
              </div>
            )
        )}
      </div>
    </div>
  );
}

export default ImageResults;
